const AddPayment = () => {
    return ('add')
}
export default AddPayment